var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},_vm._l((_vm.items),function(item){
var _obj;
return _c('button',{key:item.value,class:[_vm.$style.button, ( _obj = {}, _obj[_vm.$style.button_active] = item.value == _vm.value, _obj )],on:{"click":function($event){return _vm.onClick(item.value)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }